import en from './en.json'
import pt from './pt.json'

export const defaultLocale = 'en'

export const languages = {
  en: en,
  pt: pt,
}